import $ from 'jquery';
import { getCurrentBreakpoint } from '../utils/breakpoint';
import { Breakpoint } from '../types/breakpoint';
export default class ProductVariantColorSelect {
    static selectDeviceWrapperSelector = '.js__select-device-wrapper';
    static colorsSelector = '.js__single-product-color-select';
    static titleSelector = '.js__single-product-color-title';
    static labelWrapperSelector = '.js__product-labels';
    static labelTranslationsSelector = '.js__label-translations';
    static colorMapping = {
        out_of_stock: 'badge-error-red badge-outline',
        bundle: 'badge-amber-classical',
        available_with_trade_in: 'badge-accent',
        most_popular: 'badge-accent',
    };
    static init() {
        $(this.selectDeviceWrapperSelector).each((index, element) => {
            const $element = $(element);
            if (getCurrentBreakpoint() >= Breakpoint.lg) {
                $element.find('[data-toggle="tooltip"]').tooltip();
            }
            $element.find(this.colorsSelector).on('change', e => {
                this.handleColorChange($(e.currentTarget).closest(this.selectDeviceWrapperSelector));
            });
            setTimeout(() => {
                this.handleColorChange($(element));
            });
        });
    }
    static getSelectedColorElement($wrapper) {
        return $wrapper.find(this.colorsSelector).filter(':checked');
    }
    static getSelectedProductVariant($wrapper) {
        return this.getSelectedColorElement($wrapper).val();
    }
    static handleColorChange($wrapper) {
        const $selectedColor = this.getSelectedColorElement($wrapper);
        const labels = $selectedColor.data('labels');
        const $button = $selectedColor
            .closest('.js__select-device-wrapper')
            .find('.js__product-variant-color-select-button');
        const forceDisable = $button.data('force-disable') || false;
        $wrapper.find(this.labelWrapperSelector).empty();
        if (labels) {
            const labelArray = labels.length > 0 ? labels.split(', ') : [];
            const isOutOfStock = labelArray.includes($selectedColor.data('disable-submit-on-label'));
            $button.prop('disabled', isOutOfStock || forceDisable);
            if (labelArray.length > 0) {
                labelArray.forEach((label) => {
                    $wrapper
                        .find(this.labelWrapperSelector)
                        .append(`<li class="badge ${this.colorMapping[label]}">${$wrapper.find(this.labelTranslationsSelector).data('labels')[label]}</li>`);
                });
            }
        }
        else {
            $button.prop('disabled', forceDisable);
        }
        if (!$selectedColor.length) {
            return;
        }
        this.setTitleByColor($selectedColor, $wrapper);
        this.setImageByColor($selectedColor, $wrapper);
    }
    static setTitleByColor($color, $wrapper) {
        $wrapper.find(this.titleSelector).text($color.data('name'));
    }
    static setImageByColor($color, $wrapper) {
        $wrapper.find('.js__product-variant-image').hide();
        $wrapper.find(`.js__product-variant-image[data-variant-code="${$color.val()}"]`).show();
    }
}
